import React, { Component } from 'react';
require('smoothscroll-polyfill').polyfill();

class App extends Component {
  state={open:false, texture:false, alternative:false}
  navigation = null

  componentWillMount(){
    var landscapes = window.landscapes
      if (!landscapes) {
        landscapes = JSON.parse('[{"name":"Vandnært","description":"Ved havet findes strandengen og stranden med tang og urter. Ved ferske søer og vandløb, vokser urter og blomster.","icon":"/application/files/3114/9337/0363/Ikon_-_Havat3x.png","subLandscapes":[{"name":"Strandeng","description":"Strandengen med indsøer, højt græs og blomstrende urter. Duften og lyden af havet blandes med insekters summen og fuglesang. ","image":"/application/files/6614/9036/4082/strandeng.jpg","path":"/dk/sankelandskaber/vandnaert/strandeng-uni"},{"name":"Sø","description":"Søen med sin blanke overflade, mørke vand og frodige bred. I vandkanten står dunhammer, på bredden vokser de vilde urter.","image":"/application/files/9214/9036/4250/so.jpg","path":"/dk/sankelandskaber/vandnaert/so-uni"},{"name":"Strand","description":"Stranden med havet, opskyllet tang og grønne bælter af urter. I klitterne vokser marehalm og buskadser af hyben og havtorn. ","image":"/application/files/3914/9036/4272/strand.jpg","path":"/dk/sankelandskaber/vandnaert/strand-uni"}]},{"name":"Åbent land","description":"I det åbne landskab finder du hegn, grøfter og græsland fyldt med urter, nødder, frugter og bær.","icon":"/application/files/8514/9337/0363/Ikon_Abent_Landat3x.png","subLandscapes":[{"name":"Græsland","description":"Græslandet med bakker og åbent land hvor mange slags urter og blomster gror tæt. Enkelte træer knejser over landskabet og sommerfuglene danser.","image":"/application/files/2314/9036/4172/graesland.jpg","path":"/dk/sankelandskaber/abent-land/graesland-uni"}]},{"name":"Skov","description":"I nåleskoven og i løvskoven finder du svampe, spiselige blade, skud, urter, bær og nødder.","icon":"/application/files/6414/9337/0364/Ikon_-_skovat3x.png","subLandscapes":[{"name":"Nåleskov","description":"Nåleskoven med gran- og fyrretræer. Her er mørkt og dufter af gran og harpiks. Skovbunden er fyldt med nåle, der dæmper lyde. ","image":"/application/files/6214/9036/4694/naaleskov.jpg","path":"/dk/sankelandskaber/skov/naleskov-uni"}]},{"name":"By","description":"I byens parker, havneløb og grønne områder finder du urter, frugter, nødder og bær.","icon":"/application/files/3414/9337/0364/Ikon_BYat3x.png","subLandscapes":[{"name":"By","description":"Byen med boligblokke, cykelstier og villaveje. Hvor asfalten brydes af planter, kan du finde urter, bær og frugt, og langs vandet står kystens urter.","image":"/application/files/6814/9096/4395/sankested_by-squashed.jpg","path":"/dk/sankelandskaber/by/by-uni"}]}]')
      }
      this.setState({
        landscapes: landscapes,
        alternative: window.alternativeAnimation,
        texture: window.textureAnimation
      })
  }

  open = (num) =>{
    //Get the height it should be set to (cant animate height auto)
    const h = window.getComputedStyle(this.navigation, null).getPropertyValue("height");

    const rect = this.navigation.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollTo = rect.top + scrollTop - 110 // menu height
    window.scroll({left:0, top: scrollTo,  behavior: 'smooth' });

    if(this.state.open && this.state.open !== num && this.state.alternative){
      this.setState({open: false})
      setTimeout(()=>{
        this.setState({open: num})
      },600)
    }else{
      this.setState({open: num})
    }


  }

  render() {
    var count = 0
    return (
    <div className={this.state.texture ? "texture" : null}>
      <div className={(this.state.open !== false ? "open " : "") + "sankelandskaber"}>
        <nav
            ref={r=>this.navigation = r}
        >
          <ul>
            {
              this.state.landscapes.map((landscape,idx)=>{
                return(
                  <li
                    className={this.state.open === idx ? "active" : ""}
                    onClick={()=>this.open(idx)}>
                    <div className="info">
                      <Image className="icon" src={landscape.icon} alt="" draggable="false" />
                      <h2>{landscape.name}</h2>
                      <p>{landscape.description}</p>
                    </div>
                  </li>
                )
              })
            }
          </ul>
        </nav>

        <ul>
          {
            this.state.landscapes.map((landscape,idx)=>{

              return(
                <li
                  className={this.state.open === idx ? "active" : ""}
                  onClick={()=>this.open(idx)}>
                  <ul>
                    {
                      landscape.subLandscapes.map((subLandscape, subIDX)=>{
                        count += 1
                        return(
                          <li

                            className="sub">
                            <a
                              key={subLandscape.name}
                              href={subLandscape.path}>
                              <div className="info">
                                <h2>{subLandscape.name}</h2>
                                <p>{subLandscape.description}</p>
                                <div className="button-look transparent">
                                  {window.buttonLabel || "UDFORSK"}
                                </div>
                              </div>
                            </a>
                            <Image className="landscape-background" src={subLandscape.image} alt="" draggable="false" ></Image>
                          </li>
                    )
                  })
                  }
                  </ul>
                </li>
          )
        })
        }
        </ul>
      </div>
      </div>
    );
  }
}

export default App;



class Image extends React.Component {
  state={
    loaded:false
  }

  render() {


    return (
        <img
        {...this.props}
        ref={(i=>{
          if(i && i.complete && !this.state.loaded){
            this.setState({loaded:true})
          }
        })}
        className={
          this.props.className + (this.props.animation ? " reveal-animation " : " reveal ") +
          (this.state.loaded ? (this.props.animation ? " revealed " : " loaded ") : "")
          }
        onLoad={(()=>{
          this.setState({loaded:true})
          if (this.props.onLoad) this.props.onLoad()
          })}

       />
    );
  }
}



// WEBPACK FOOTER //
// ./src/LandscapesMenu.js